import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Select from 'react-select';
import { base_url } from '../../Api/Api';
import PulseLoader from "react-spinners/PulseLoader";
import Popup from '../../Common/Popup';

const NewtTicket = (props) => {

    const [state, setState] = useState({
        categorySubject: [],
        subjectValue: '',
        imgUrl: '',
        titleValue: '',
        descriptionValue: '',
        validInput: false,
        loader: false,
        popup: false,
        textApi: ''
    })

    useEffect(() => {


        base_url.get(`ticket_categories`)
            .then(response => {
                setState({
                    ...state,
                    categorySubject: response.data.ticketcategories
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    }
                }
            })

    }, []);

    const handleChange = selectedOption => {
        setState({
            ...state,
            subjectValue: selectedOption
        });
    };

    const loadFile = (event) => {
        var image = document.getElementById('output');
        image.src = URL.createObjectURL(event.target.files[0]);
        setState({
            ...state,
            imgUrl: image.src
        })
    };

    const deletePictuer = () => {
        var image = document.getElementById('output');
        image.src = '';
        setState({
            ...state,
            imgUrl: ''
        })
    }

    const changeInput = (value, taget) => {
        setState({
            ...state,
            [taget]: value
        })
    }

    const submitTicket = () => {
        if (state.subjectValue.length !== 0 &&
            state.titleValue.length >= 3 &&
            state.descriptionValue.length >= 3) {

            setState({
                ...state,
                loader: true
            })
            if (state.imgUrl.length == 0) {

                const dataWithoutImg = {
                    category_id: state.subjectValue.value,
                    title: state.titleValue,
                    message: state.descriptionValue
                };
                base_url.post(`tickets`, dataWithoutImg)
                    .then(resp => {
                        if (resp.data.status == 1) {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'پیام شما با موفقیت ارسال شد',
                                loader: false,
                                subjectValue: '',
                                imgUrl: '',
                                titleValue: '',
                                descriptionValue: '',
                            })
                        } else {
                            setState({
                                ...state,
                                popup: true,
                                textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                loader: false,
                                subjectValue: '',
                                imgUrl: '',
                                titleValue: '',
                                descriptionValue: '',
                            })
                        }
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            }
                        }
                    })
            } else {

                var data = new FormData(document.getElementById("form"));
                base_url.post(`ticket_image`, data)
                    .then(response => {

                        const dataTicket = {
                            category_id: state.subjectValue.value,
                            title: state.titleValue,
                            message: state.descriptionValue,
                            ticketAttach: response.data.ticketAttach
                        };
                        base_url.post(`tickets`, dataTicket)
                            .then(resp => {
                                if (resp.data.status == 1) {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'پیام شما با موفقیت ارسال شد',
                                        loader: false,
                                        subjectValue: '',
                                        imgUrl: '',
                                        titleValue: '',
                                        descriptionValue: '',
                                    })
                                } else {
                                    setState({
                                        ...state,
                                        popup: true,
                                        textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                        loader: false,
                                        subjectValue: '',
                                        imgUrl: '',
                                        titleValue: '',
                                        descriptionValue: '',
                                    })
                                }
                            })
                            .catch(error => {
                                if (error.response != undefined) {
                                    if (error.response.status == 401) {
                                        props.history.push(`/Entrance`)
                                    } else {
                                        setState({
                                            ...state,
                                            popup: true,
                                            textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                            loader: false,
                                            subjectValue: '',
                                            imgUrl: '',
                                            titleValue: '',
                                            descriptionValue: '',
                                        })
                                    }
                                }
                            })
                    })
                    .catch(error => {
                        if (error.response != undefined) {
                            if (error.response.status == 401) {
                                props.history.push(`/Entrance`)
                            } else {
                                setState({
                                    ...state,
                                    popup: true,
                                    textApi: 'مشکلی بوجود آمده لطفا دوباره سعی کنید',
                                    loader: false,
                                    subjectValue: '',
                                    imgUrl: '',
                                    titleValue: '',
                                    descriptionValue: '',
                                })
                            }
                        }
                    })
            }

        } else {
            setState({
                ...state,
                validInput: true
            })
        }
    }

    const closePopup = () => {
        setState({
            ...state,
            popup: false
        })
        props.history.goBack()
    }

    return (
        <div className="newTicket">
            <Popup
                active={state.popup} >
                <h4>{state.textApi}</h4>
                <Button
                    variant="contained"
                    onClick={closePopup} >تایید</Button>
            </Popup>
            <div className="contain">
                <div className="ticketInfo">
                    <span className="title">ارسال تیکت جدید</span>
                    <div className="form">
                        <div className="input-form">
                            <div className="item-input">
                                <Select
                                    value={state.subjectValue}
                                    onChange={handleChange}
                                    options={state.categorySubject.map(info => {
                                        return { value: info.id, label: info.name }
                                    })}
                                    placeholder="موضوع"
                                />
                                <span className={`error-respns ${state.subjectValue.length == 0 && state.validInput ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                    متن پیام خود کامل وارد کنید
                                </span>
                            </div>
                            <div className="item-input">
                                <TextField
                                    className="title-input"
                                    label="عنوان پیام"
                                    type='text'
                                    value={state.titleValue}
                                    onChange={(e) => changeInput(e.target.value, 'titleValue')} />
                                <span className={`error-respns ${state.titleValue.length <= 3 && state.validInput ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                    متن پیام خود کامل وارد کنید
                                </span>
                            </div>
                            <div className="item-input">
                                <TextField
                                    className="description-input"
                                    label="متن پیام"
                                    multiline
                                    rowsMax={6}
                                    value={state.descriptionValue}
                                    onChange={(e) => changeInput(e.target.value, 'descriptionValue')} />
                                <span className={`error-respns ${state.descriptionValue.length <= 3 && state.validInput ? 'active' : ''}`}>
                                    <i className="icon-exclamation-mark"></i>
                                    متن پیام خود کامل وارد کنید
                                </span>
                            </div>
                        </div>
                        <div className="upload">
                            <div className={`pic-ticket ${state.imgUrl.length == 0 ? '' : 'active'}`}>
                                <form className="up" id="form">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        name="ticketAttach"
                                        id="file"
                                        onChange={(event) => loadFile(event)} />
                                    <span> <i className="icon-upload"></i> آپلود عکس</span>
                                </form>
                                <div className="selected-pic">
                                    <img id="output" src="" />
                                    <div className="overlay-delete">
                                        <i className="icon-bin" onClick={deletePictuer}></i>
                                    </div>
                                </div>
                            </div>
                            {state.loader ?
                                <Button
                                    variant="contained" >
                                    <PulseLoader
                                        color="#fff"
                                        loading={state.loading}
                                        size={12} />
                                </Button>
                                :
                                <Button
                                    variant="contained"
                                    onClick={submitTicket} >ارسال</Button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewtTicket;